import { LitEntity, SirenActionMixin, html, css } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-flash';
import '../../common/bn-form-field';

class ChangePassword extends SirenActionMixin(LitEntity) {
  static get properties() {
    return {
      password: { type: String, attribute: false },
      confirm: { type: String, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        display: block;
      }
    `];
  }

  render() {
    const disableSubmit = !this.password || this.password !== this.confirm;
    return html`
      <form @submit="${this._submit}">
        <bn-flash></bn-flash>

        <bn-form-field type="password" name="currentPassword" title="Current Password" @keyup="${this._update}"></bn-form-field>
        <bn-form-field type="password" name="password" title="New Password" @keyup="${this._update}"></bn-form-field>
        <bn-form-field type="password" name="confirm" title="Confirm New Password" @keyup="${this._update}"></bn-form-field>

        <div class="form-actions">
          <button class="button button--contained" ?disabled="${disableSubmit}" type="submit">Change Password</button>
        </div>
      </form>
    `;
  }

  updated(props) {
    super.updated(props);
    this._update();
  }

  _inputValue(name) {
    const field = this.shadowRoot.querySelector(`bn-form-field[name="${name}"]`);
    return field.input ? field.input.value : undefined;
  }

  _update() {
    this.password = this._inputValue('password');
    this.confirm = this._inputValue('confirm');
    this.currentPassword = this._inputValue('currentPassword');
  }

  async _submit(e) {
    e.preventDefault();
    const action = this.entity.getActionByName('change-password');
    if (!action) {
      return;
    }
    const flash = this.shadowRoot.querySelector('bn-flash');
    flash.clear();
    try {
      const fields = this.getActionFields(action);
      fields.set('password', this.password);
      fields.set('currentPassword', this.currentPassword);
      const { error } = await this.submitAction(action, fields);
      if (error) {
        throw new Error(error);
      }
      flash.success('Password updated.');
    } catch (error) {
      flash.critical(html`Could not change password.<br/><code>${error.message}</code>`);
    }
  }
}

window.customElements.define('change-password', ChangePassword);
